export const TOOL = {
  VIDEO_DOWNLOADER: 'VIDEO_DOWNLOADER',
  VIDEO_CONVERTER: 'VIDEO_CONVERTER',
  AUDIO_CONVERTER: 'AUDIO_CONVERTER',
  PPT_TO_VIDEO: 'PPP_TO_VIDEO',
  TEXT_TO_SPEECH: 'TEXT_TO_SPEECH',
  AI_SCRIPT_GENERATOR: 'AI_SCRIPT_GENERATOR',
  AI_IMAGE_GENERATOR: 'AI_IMAGE_GENERATOR',
  AI_VIDEO_GENERATOR: 'AI_VIDEO_GENERATOR',
  SCREEN_RECORDING: 'SCREEN_RECORDING',
  AUTO_CAPTION: 'AUTO_CAPTION',
  VIDEO_TRIM_MERGE_CROP: 'VIDEO_TRIM_MERGE_CROP',
  SOLID_BACKGROUND_VIDEO: 'SOLID_BACKGROUND_VIDEO',
} as const

export type Tool = (typeof TOOL)[keyof typeof TOOL]

export const TOOL_LOCAL_STORAGE_KEY_PREFIX = 'ai-studio-tool'
